export const EXPLORER_PREFERENCE_TABLE = "platform_studio";
export const EXPLORER_PREFERENCE_KEY = "studio.explorer.expanded";

export const STUDIO_ACTIVITY_WIDTH = 44;
export const STUDIO_RESIZE_HANDLE_WIDTH = 6;
export const STUDIO_LEFT_PANEL_DEFAULT_WIDTH = 330;
export const STUDIO_RIGHT_PANEL_DEFAULT_WIDTH = 520;
export const STUDIO_LEFT_PANEL_MIN_WIDTH = 240;
export const STUDIO_LEFT_PANEL_MAX_WIDTH = 560;
export const STUDIO_RIGHT_PANEL_MIN_WIDTH = 320;
export const STUDIO_RIGHT_PANEL_MAX_WIDTH = 860;
